'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUnseenThreadsCountExcludeCurrent = undefined;

var _reselect = require('reselect');

var _getThreadList = require('./getThreadList');

var _getCurrentThread = require('./getCurrentThread');

var calculateUnseenThreadsCountExcludeCurrent = exports.calculateUnseenThreadsCountExcludeCurrent = (0, _reselect.createSelector)([_getThreadList.getThreadList, _getCurrentThread.getCurrentThread], function (threads, currentThread) {
  if (!threads) {
    return 0;
  }
  return threads.reduce(function (unseenCount, thread) {
    if (thread !== currentThread) {
      return unseenCount + (thread.unseenCount ? 1 : 0);
    }
    return unseenCount;
  }, 0);
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/calculateUnseenThreadsCountExcludeCurrent.js
// module id = 327
// module chunks = 2 3